import { Button, Modal } from '@teo/components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { axios } from '@/axios';
import { config } from '@/config';
import { newUid, extractTextFromElement } from '@/util';

const AskGPT = ({
  state,
  answer,
  userId,
  setFeedback,
  setScore,
  setUpdateFeedback,
  setIsLoading,
  userLang,
}: any) => {
  const { t } = useTranslation();

  async function handleSubmit() {
    setIsLoading(true);
    const questionDiv = document.createElement('div');
    const answerDiv = document.createElement('div');
    const antwoordDiv = document.createElement('div');
    const questionTitleDiv = document.createElement('div');
    questionDiv.innerHTML = state?.vraag;
    questionTitleDiv.innerHTML = state?.titleWidget;
    answerDiv.innerHTML = answer?.answer;
    antwoordDiv.innerHTML = state?.antwoord;

    const readableQuestio = extractTextFromElement(questionDiv);
    const readableTitleQuestio = extractTextFromElement(questionTitleDiv);
    const readableAnswer = extractTextFromElement(answerDiv);
    const readableAntwoord = extractTextFromElement(antwoordDiv);

    let questionImg = null;
    let answerImg = null;
    const questionImgList = state?.vraag.match(/<img[^>]+src="([^">]+)"/);
    const answerImgList = answer?.answer.match(/<img[^>]+src="([^">]+)"/);

    if (questionImgList) {
      questionImg = questionImgList[1];
    }

    if (answerImgList) {
      answerImg = answerImgList[1];
    }

    const questionText = readableQuestio.replace(/\n\s*\n/g, '\n').trim();
    const questionTitleText = readableTitleQuestio
      .replace(/\n\s*\n/g, '\n')
      .trim();
    const answerText = readableAnswer.replace(/\n\s*\n/g, '\n').trim();
    const antwoordText = readableAntwoord.replace(/\n\s*\n/g, '\n').trim();

    const textContent = [
      {
        type: 'text',
        text: `question:${questionTitleText}${
          questionText ? ' - ' + questionText : ''
        }, answer:${answerText}, possible_answer: ${
          antwoordText ? antwoordText : null
        }`,
      },
    ];

    const questionImgContent = [
      {
        type: 'text',
        text: `question: ${questionText}; answer: ${answerText}; possible_answer: ${
          antwoordText ? antwoordText : null
        }; ${'question_image: ' + !!questionImg}; ${
          'answer_image: ' + !!answerImg
        }`,
      },
      {
        type: 'image_url',
        image_url: { url: questionImg ? questionImg : '' },
      },
    ];

    const answerImgContent = [
      {
        type: 'text',
        text: `question: ${questionText}; answer: ${answerText}; possible_answer: ${
          antwoordText ? antwoordText : null
        }; ${'question_image: ' + !!questionImg}; ${
          'answer_image: ' + !!answerImg
        }`,
      },
      {
        type: 'image_url',
        image_url: { url: answerImg ? answerImg : '' },
      },
    ];

    const allImgContent = [
      {
        type: 'text',
        text: `question: ${questionText}; answer: ${answerText}; possible_answer: ${
          antwoordText ? antwoordText : null
        }; ${'question_image: ' + !!questionImg}; ${
          'answer_image: ' + !!answerImg
        }`,
      },
      {
        type: 'image_url',
        image_url: { url: questionImg ? questionImg : '' },
      },
      {
        type: 'image_url',
        image_url: { url: answerImg ? answerImg : '' },
      },
    ];

    let systemPromt;
    switch (userLang) {
      case 'nl':
        systemPromt = `U bent een deskundige leraar die gespecialiseerd is in wiskunde, natuurkunde, scheikunde en verwante wetenschappen. U ontvangt een vraag (question:any) en een antwoord (answer:any). 'question': dit is de vraag die u de student stelt, 'answer': dit is het antwoord van de student. U krijgt mogelijk ook een mogelijk antwoord (possible_answer) waarvan u denkt dat dit het juiste antwoord is op de vraag (question), dat u moet vergelijken met het antwoord van de student. U kunt ook een afbeelding krijgen die betrekking heeft op de vraag of het antwoord, d.w.z. als question_image:true dan heeft de afbeelding betrekking op de vraag en als answer_image:true dan heeft de afbeelding betrekking op het antwoord van de student, maar als zowel question_image:true als answer_image:true dan krijgt u twee afbeeldingen, de eerste verwijst naar de vraag en de tweede naar het antwoord. Allereerst, op basis van het mogelijke antwoord (mogelijk_antwoord), als het bestaat, als het niet bestaat, dan moet u als docent op basis van uw kennisbasis het antwoord van de student (antwoord) beoordelen van 0 tot ${state?.score} en het vergelijken met uw antwoord (mogelijk_antwoord) als het bestaat, waarbij u alle vaagheid of informele taal negeert, d.w.z. als het een wiskundevraag is, controleert u of de student het juiste antwoord heeft gegeven, maar u negeert hoe hij het heeft gekregen of of hij informele taal in het antwoord heeft gebruikt, het belangrijkste is of het antwoord correct is of niet, maar als dit een theoretische vraag is, dan kijkt u al naar de context van het antwoord, maar als basis voor de controle neemt u het mogelijke antwoord (mogelijk_antwoord) als het er is, als het er niet is, dan naar uw kennisbasis en geeft u ook constructieve feedback aan de student met betrekking tot zijn antwoord, en deze beoordeling en feedback worden in JSON weergegeven. JSON moet de volgende indeling hebben: {score: rating(number),feedback: feedback(string),}`;
        break;
      case 'fr':
        systemPromt = `Vous êtes un enseignant compétent spécialisé en mathématiques, physique, chimie et sciences connexes. Vous recevrez une question (question:any) et une réponse (answer:any). 'question': il s'agit de la question que vous posez à l'élève, 'answer': il s'agit de la réponse de l'élève. Vous pouvez également recevoir une réponse possible (possible_answer) que vous pensez être la bonne réponse à la question (question), que vous devrez comparer avec la réponse de l'élève. Vous pouvez également recevoir une image qui se rapportera soit à la question, soit à la réponse, c'est-à-dire si question_image:true alors l'image se rapporte à la question et si answer_image:true alors l'image se rapporte à la réponse de l'élève, mais si question_image:true et answer_image:true alors vous recevrez deux images, la première se rapportant à la question et la seconde à la réponse. Tout d'abord, en vous appuyant sur la réponse possible (possible_answer), si elle existe, si elle n'existe pas, alors en vous basant sur votre base de connaissances, vous, en tant qu'enseignant, devez noter de 0 à ${state?.score} la réponse de l'élève (answer) en la comparant à votre réponse (possible_answer) si elle existe, en ignorant toute imprécision ou langage informel, c'est-à-dire s'il s'agit d'une question mathématique, vous vérifiez si l'élève a donné la bonne réponse, mais vous ignorez comment il l'a obtenue ou s'il a utilisé un langage informel dans la réponse, l'essentiel est de savoir si la réponse est correcte ou non, mais s'il s'agit d'une question théorique, alors vous regardez déjà le contexte de la réponse mais comme base de vérification, prenez la réponse possible (possible_answer) si elle est là si elle n'est pas là, alors dans votre base de connaissances et fournissez également des commentaires constructifs à l'élève concernant sa réponse, et cette note et ces commentaires s'affichent au format JSON. JSON doit avoir le format suivant : {score: rating(number),feedback: feedback(string),}`;
        break;
      default:
        systemPromt = `You are a knowledgeable teacher specializing in mathematics, physics, chemistry, and related sciences. You will receive a question (question:any) and an answer (answer:any). A question: this is the question you ask the student, answer: this is the student's answer. You may also be given a possible answer (possible_answer) that you think is the correct answer to the question (question), which you will need to compare with the student's answer. You can also be provided with an image that will relate either to the question or to the answer, i.e. if question_image:true then the image relates to the question and if answer_image:true then the image relates to the student's answer but if both question_image:true and answer_image:true then you will be provided two images, the first refers to the question and the second to the answer. First of all, relying on the possible answer (possible_answer), if it exists, if it does not exist, then based on your knowledge base, you, as the teacher, must rate from 0 to ${state?.score} the student's answer (answer) comparing it to your answer (possible_answer) if it exists, ignoring any vagueness or informal language, ie if it is a math question you are checking whether the student gave the correct answer, but you ignore how he got it or if he used informal language in the answer, the main thing is whether the answer is correct or not, but if this is a theoretical question, then you already look at the context of the answer but as a basis for checking take the possible answer (possible_answer) if it is there if it is not then to your knowledge base and also provide constructive feedback to the student regarding his answer, and this rating and feedback display JSON. JSON should have the following format: {score: rating(number),feedback: feedback(string),}`;
        break;
    }

    try {
      const dataOpenAI = await axios.post(`${config.backend}/openai`, {
        response_format: { type: 'json_object' },
        messages: [
          {
            role: 'developer',
            content: systemPromt,
          },
          {
            role: 'user',
            content:
              questionImg && answerImg
                ? allImgContent
                : questionImg && !answerImg
                ? questionImgContent
                : !questionImg && answerImg
                ? answerImgContent
                : textContent,
          },
        ],
        model: 'gpt-5.2',
        temperature: 0.8,
        // model: questionImg || answerImg ? 'gpt-4o' : 'gpt-4-0125-preview',
        max_completion_tokens: 2500,
        user: `${userId}`,
      });
      const fullAnswer = dataOpenAI?.data?.choices[0]?.message?.content || '';
      setIsLoading(false);

      const jsonObject = fullAnswer
        ? JSON.parse(fullAnswer)
        : {
            score: 0,
            feedback: dataOpenAI?.data?.choices[0]?.message?.refusal,
          };

      if (jsonObject) {
        setScore(parseFloat(jsonObject?.score));
        setFeedback(jsonObject?.feedback);
        setUpdateFeedback(newUid(20));
      }
    } catch (e) {
      alert(`Error: ${e}`);
      setIsLoading(false);
    }
  }

  return (
    <>
      <div className="mb-5 mt-2 flex flex-col gap-1">
        <p className="text-sm text-grey-06">
          {t('pages.correction_result.teo_ai_text')}
        </p>
        <div>
          <Button
            className="flex items-center"
            onClick={() => {
              handleSubmit();
              // setIsOpenModal(true);
            }}
          >
            <img
              src="/images/icons/chatgpt.svg"
              alt="chatgpt"
              className="mr-2 w-5"
            />
            {t('pages.correction_result.ask_teoai')}
          </Button>
        </div>
      </div>
    </>
  );
};

export { AskGPT };
